import GuestLayout from '@/layouts/GuestLayout.vue';
import NoHeader from '@/layouts/NoHeader.vue';

const routes = [
  {
    path: '/usage-credentials-collected',
    name: 'UsageCredentialsCollected',
    meta: {
      requiresAuth: false,
      layout: NoHeader,
      title: 'Credentials Collected'
    },
    component: () => import('@/views/UsageCredentialsCollected.vue')
  },
  {
    path: '/guest-login',
    name: 'GuestLogin',
    meta: {
      requiresAuth: false,
      layout: GuestLayout,
      title: 'Guest login'
    },
    component: () => import('@/views/GuestLogin.vue')
  },
  {
    path: '/guest-logout',
    name: 'GuestLogout',
    meta: {
      requiresAuth: false,
      layout: GuestLayout,
      title: 'Guest logout'
    },
    component: () => import('@/views/GuestLogout.vue')
  },
  {
    path: '/homeowner/:jobId',
    name: 'HomeownerLandingPage',
    meta: {
      requiresGuestAuth: true,
      layout: GuestLayout,
      title: 'Homeowner Profile',
      isHomeowner: true
    },
    component: () => import('@/views/HomeownerLandingPage.vue')
  },
  {
    path: '/installer/:jobId',
    name: 'InstallerLandingPage',
    meta: {
      requiresGuestAuth: true,
      layout: GuestLayout,
      title: 'Installer Profile'
    },
    component: () => import('@/views/InstallerLandingPage.vue')
  }
];

export default routes;
